import {
  HIRED_EQUIPMENT_FORM_TYPE,
  HIRED_EQUIPMENT_MODULE_LABEL,
} from '../../hired-equipment/config/moduleCopy';

/**
 * Submissions type tabs. `value` is sent as `formType` and matched against Form.name.
 * Stored Form.status values (not a Prisma enum): pending, approved, need revisions,
 * declined, plus revisions completed (rolled into the Pending counter).
 */
export const APPROVAL_FORM_TYPES = [
  { label: 'All Form Submissions', value: 'all' },
  { label: 'Daily Log', value: 'Daily Log' },
  { label: HIRED_EQUIPMENT_MODULE_LABEL, value: HIRED_EQUIPMENT_FORM_TYPE },
] as const;

export type ApprovalFormType = (typeof APPROVAL_FORM_TYPES)[number]['value'];

/** Status pills on Submissions. Labels match stored Form.status strings. */
export const APPROVAL_STATUS_FILTERS = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'need revisions', label: 'Need Revisions' },
  { value: 'declined', label: 'Declined' },
  { value: 'all', label: 'All Statuses' },
] as const;

export type ApprovalStatusFilter = (typeof APPROVAL_STATUS_FILTERS)[number]['value'];
